import {ViewStream} from 'spyne';

export class PageDeckSlideView extends ViewStream {
    
    constructor(props={}) {
        
        super(props);
    }
    
    addActionListeners() {
        // return nexted array(s)
        return [];
    }
    
    broadcastEvents() {
        // return nexted array(s)
        return [];
    }
   
    onRendered() {
    
    }
    
}

